import React, { useEffect, useState } from 'react'
import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import { useSelector } from 'react-redux';
import FRTableRow from './FRTableRow';

const FRTable = ({lotteryContract}) => {
    
    const {connect} = useSelector (
      state => state.provider
    );

    const [currentRoundNumber, setCurrentRoundNumber] = useState (0);
  const [roundNumber, setRoundNumber] = useState (0);
  const [history, setHistory] = useState ([]);


  useEffect (()=>{

    if(connect){
      console.log("fetch");
      getRoundNumber();
    }

  },[connect])
  
  const getRoundNumber = async () => {
    const round = await lotteryContract.functions.roundNumber ();
    setCurrentRoundNumber (round.toString ());
    setRoundNumber (parseInt (round.toString ()) - 1);
  };

  useEffect (()=>{
    if(connect){
      getRoundHistory();
    }
  },[roundNumber])

  const getRoundHistory = async () => {
    const info = await lotteryContract.functions.getYourHistory(roundNumber);
    console.log("Round history",info[0]);
    setHistory (info[0]);
    
  };

  return (
    <div className='min-w-[70vw]'> 
        <div className="max-w-4xl mx-auto  ">
        <div className="block px-6 py-4 bg-black/50 rounded-t-2xl border border-black/20 shadow-md cursor-pointer ">
                  <div className="flex flex-col space-y-1">
                    <div className="flex justify-between items-center">
                      <div className="flex items-center">
                        <p className="text-lyellow text-xl font-semibold">
                          Round
                        </p>
                        <span className="ml-5 rounded-full bg-[#2a3137] px-3 py-1">
                          {parseInt (roundNumber)}
                        </span>
                      </div>
                      <div className="flex items-center justify-between">
                        <AiOutlineArrowLeft
                          className="mr-2 text-lg"
                          onClick={() => {
                            if (parseInt (roundNumber) - 1 > 0) {
                              setRoundNumber (parseInt (roundNumber) - 1);
                            }
                          }}
                        />
                        <AiOutlineArrowRight
                          className="ml-2 text-lg"
                          onClick={() => {
                            if (roundNumber + 1 < currentRoundNumber) {
                              setRoundNumber (parseInt (roundNumber) + 1);
                            }
                          }}
                        />
                      </div>
                    </div>
                    
                  </div>
                </div>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full  text-left text-white ">
            <thead className="font-semibold text-lyellow uppercase bg-black/60">
              <tr>
                <th scope="col" className="px-6 py-3">
                  #
                </th>
                <th scope="col" className="px-6 py-3 w-full text-center">
                  Guess
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3">
                  Price
                </th>
                <th scope="col" className="px-6 py-3">
                  Category
                </th>
              </tr>
            </thead>
            <tbody className="text-sm">
            {
                history.length >0 ? history.map((hist,index) => (
                    <>
                        <FRTableRow  key={index} history={hist} index={index} />
                    </>
                ) ) : (<>
                  
                </>)
            }
            </tbody>
          </table> 
          {history.length==0?
            <>
              <div className='text-2xl font-semibold tracking-wide m-5 flex justify-center items-center w-full'>
                  <p className='text-lyellow text-center'>No History Found!</p>
              </div>
          </> 
          :null
        } 
                  
        </div>
      </div>
    </div>
  )
}

export default FRTable